/* ============================================================
   KeyFinder Pro™ — assets/kf-keyfinder.js
   Vanilla JS, sin dependencias. No toca global.js ni el carrito del tema.
   ============================================================ */
(function () {
  'use strict';

  var state = { variantId: null, qty: 1, total: '', label: '' };
  var busy = false;

  /* ---------- utilidades ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return String(n).padStart(2, '0'); }

  function ripple(e, el) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = el.getBoundingClientRect();
    var d = Math.max(r.width, r.height);
    var s = document.createElement('span');
    s.className = 'kf-ripple';
    s.style.width = s.style.height = d + 'px';
    s.style.left = (e.clientX - r.left - d / 2) + 'px';
    s.style.top = (e.clientY - r.top - d / 2) + 'px';
    el.appendChild(s);
    requestAnimationFrame(function () { s.style.transform = 'scale(2.4)'; s.style.opacity = '0'; });
    setTimeout(function () { s.remove(); }, 650);
  }

  /* ---------- 1. Selector de packs ---------- */
  function initPacks() {
    var root = $('[data-kf-packs]');
    if (!root) return;
    var packs = $$('[data-kf-pack]', root);

    function select(btn) {
      packs.forEach(function (p) { p.setAttribute('aria-checked', p === btn ? 'true' : 'false'); });
      state.variantId = btn.getAttribute('data-variant-id');
      state.qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
      state.total = btn.getAttribute('data-total') || '';
      state.label = btn.getAttribute('data-label') || '';
      $$('[data-kf-total]').forEach(function (n) { n.textContent = state.total; });
      $$('[data-kf-label]').forEach(function (n) { n.textContent = state.label; });
    }

    packs.forEach(function (btn) {
      if (btn.dataset.kfBound === '1') return;
      btn.dataset.kfBound = '1';
      btn.addEventListener('click', function () { select(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(btn); }
      });
    });

    var preset = packs.filter(function (p) { return p.getAttribute('data-default') === 'true'; })[0];
    select(preset || packs[packs.length - 1] || packs[0]);
  }

  /* ---------- 2. Compra directa → /checkout ---------- */
  function addAndCheckout(btn) {
    if (!state.variantId) { showError(btn, 'Elige un pack para continuar.'); return; }
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    var original = btn.getAttribute('data-label-busy') || 'Procesando…';
    var text = $('[data-kf-cta-text]', btn);
    var prev = text ? text.textContent : '';
    if (text) text.textContent = original;

    /* update.js fija la cantidad exacta (no acumula como add.js) */
    var updates = {};
    updates[String(state.variantId)] = state.qty;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/$/, '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || ('HTTP ' + res.status));
          return data;
        });
      })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function (err) {
        busy = false;
        btn.removeAttribute('aria-busy');
        if (text) text.textContent = prev;
        console.error('[KeyFinder] add to cart:', err);
        showError(btn, (err && err.message ? err.message : 'No pudimos agregar el producto.') + ' Intenta de nuevo.');
        /* fallback: permalink de checkout */
        setTimeout(function () { window.location.assign('/cart/' + state.variantId + ':' + state.qty + '?checkout'); }, 900);
      });
  }

  function showError(btn, msg) {
    var box = document.querySelector('[data-kf-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
    else if (btn) { var t = document.createElement('p'); t.className = 'kf-error'; t.textContent = msg; btn.parentNode.insertBefore(t, btn.nextSibling); }
  }

  function initCtas() {
    $$('[data-kf-buy]').forEach(function (btn) {
      if (btn.dataset.kfBound === '1') return;
      btn.dataset.kfBound = '1';
      btn.addEventListener('click', function (e) {
        ripple(e, btn);
        var forced = btn.getAttribute('data-force-variant');
        if (forced) {
          var target = $$('[data-kf-pack]').filter(function (p) { return p.getAttribute('data-variant-id') === forced; })[0];
          if (target) target.click();
        }
        setTimeout(function () { addAndCheckout(btn); }, 120);
      });
    });
  }

  /* ---------- 3. Countdown ---------- */
  var timersOn = false;
  function initCountdown() {
    var els = $$('[data-kf-countdown]');
    if (!els.length || timersOn) return;
    timersOn = true;
    var hours = parseFloat(els[0].getAttribute('data-kf-countdown')) || 3;
    var KEY = 'kf_deadline_v1';
    var deadline = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + hours * 3600 * 1000;
      localStorage.setItem(KEY, String(deadline));
    }
    function tick() {
      var left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var txt = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left / 60) % 60) + ':' + pad(left % 60);
      els.forEach(function (el) { el.textContent = txt; });
      if (left === 0) { deadline = Date.now() + hours * 3600 * 1000; localStorage.setItem(KEY, String(deadline)); }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- 4. Stock dinámico 8–15 ---------- */
  var stockOn = false;
  function initStock() {
    var els = $$('[data-kf-stock]');
    if (!els.length || stockOn) return;
    stockOn = true;
    var KEY = 'kf_stock_v1';
    var n = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!n) { n = 8 + Math.floor(Math.random() * 8); sessionStorage.setItem(KEY, String(n)); }
    function paint() { els.forEach(function (el) { el.textContent = n; }); }
    paint();
    setInterval(function () {
      n = Math.max(8, Math.min(15, n + (Math.random() < 0.65 ? -1 : 1)));
      sessionStorage.setItem(KEY, String(n));
      paint();
    }, 22000);
  }

  /* ---------- 5. Reveal al hacer scroll ---------- */
  function initReveal() {
    var els = $$('.kf-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 6. Sticky ATC móvil ---------- */
  function initSticky() {
    var bar = $('[data-kf-sticky]');
    var anchor = $('[data-kf-packs]');
    if (!bar || !anchor || bar.dataset.kfBound === '1') return;
    bar.dataset.kfBound = '1';
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  function boot() {
    initPacks(); initCtas(); initCountdown(); initStock(); initReveal(); initSticky();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  /* recarga en el editor de temas */
  document.addEventListener('shopify:section:load', boot);
})();